/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindAllQueryResponse, AgreementsControllerFindAll401 } from "../../models/agreementsController/AgreementsControllerFindAll";

function getAgreementsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/agreements` as const }  
  return res
}

/**
 * @summary List all active agreements
 * {@link /api/v1/agreements}
 */
export async function agreementsControllerFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgreementsControllerFindAllQueryResponse, ResponseErrorConfig<AgreementsControllerFindAll401>, unknown>({ method : "GET", url : getAgreementsControllerFindAllUrl().url.toString(), ... requestConfig })  
  return res.data
}